import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { AuthService } from "./auth.service";
import { SessionExpiryService } from "./session-expiry.service";

/**
 * Protege rotas autenticadas e redireciona visitantes para o login.
 *
 * Quando o JWT expira com sessão ativa (portal no sessionStorage),
 * exibe o modal de sessão expirada em vez de redirecionar silenciosamente.
 */
@Injectable({ providedIn: 'root' })
export class AuthGuardService implements CanActivate {
  constructor(
    public auth: AuthService,
    public router: Router,
    private sessionExpiry: SessionExpiryService,
  ) {}

  /**
   * Permite login apenas sem sessão válida; demais rotas exigem JWT ativo.
   *
   * @param _route - Snapshot da rota ativada
   * @param state - Estado atual do router (URL)
   * @returns true se a navegação pode prosseguir
   */
  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const url = state.url;

    if (url.includes("/authLogin")) {
      if (this.auth.isAuthenticated()) {
        this.router.navigate(["/pages/dashboard"]);
        return false;
      }
      return true;
    }

    if (!this.auth.isAuthenticated()) {
      const hadSession = !!sessionStorage.getItem("portal");

      if (hadSession) {
        this.sessionExpiry.showSessionExpiredModal();
      } else {
        this.router.navigate(["/pages/authLogin/login"]);
      }
      return false;
    }

    return true;
  }
}
